import React, { Component } from 'react';
import { observable, action, reaction } from 'mobx';
import { observer } from 'mobx-react';
import SimpleUploader from 'simple-uploader';

import { url } from 'js/services/Network';
import AnonymousId from 'js/services/AnonymousId';

import ImagePlaceholder from 'js/components/common/ImagePlaceholder';
import Spinner from './Spinner';
import ImageDisplay from './ImageDisplay';
import AddImage from './AddImage';
import Dropzone from './Dropzone';

function noop() {}

@observer
export default class Image extends Component {
  imageUpdate = null;
  files = [];
  @observable image = '';
  @action setImage = image => (this.image = image);

  @observable isHoveringFiles = false;
  @action hoveringFiles = () => (this.isHoveringFiles = true);
  @action notHoveringFiles = () => (this.isHoveringFiles = false);

  @observable uploadFilesError = null;
  @action setUploadFilesError = error => {
    this.uploadFilesError = error;
    (this.props.setError || noop)(error);
  };
  @action clearUploadFilesError = () => {
    this.uploadFilesError = null;
    (this.props.setError || noop)(null);
  };

  @observable isUploadingFiles = false;
  @action uploadingFiles = () => (this.isUploadingFiles = true);
  @action notUploadingFiles = () => (this.isUploadingFiles = false);

  componentDidMount() {
    this.setImage(this.props.image);
    this.imageUpdate = reaction(() => this.props.image, this.setImage);
  }

  componentWillUnmount() {
    this.imageUpdate();
  }

  uploadImage(fileElement) {
    this.uploadingFiles();

    const uploadParams = {
      _token: window.app.csrf_token,
      anonymous_id: AnonymousId,
    };

    if (this.props.applyChange) {
      uploadParams.apply_change = true;
    }

    return new Promise((resolve, reject) => {
      const uploader = new SimpleUploader({
        url: this.props.alias
          ? url('payment-link-upload-image', {
              alias: this.props.alias,
            })
          : url('payment-link-upload-anonymous-image'),
        params: uploadParams,
      });
      uploader.on('uploadsuccess', (file, response) => resolve(response.xhr.responseJSON));
      uploader.on('uploaderror', (file, response) => reject(response));
      uploader.upload(fileElement);

    })
      .then(response => {
        (this.props.onUpload || noop)(response.url);
      })
      .then(() => this.notUploadingFiles())
      .catch(error => {
        const response = error.xhr.responseJSON;
        this.setUploadFilesError(
          response.errors && response.errors.upload_file ? response.errors.upload_file[0] : response.message,
        );
        this.notUploadingFiles();
      });
  }


  onDropFiles = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length) {
      this.setUploadFilesError('Invalid file chosen, please choose another.');
      this.notHoveringFiles();
    } else {
      this.clearUploadFilesError();
      this.notHoveringFiles();
      let sum = acceptedFiles.reduce(function(prev, current) {
        return prev + +current.size
      }, 0);

      if (parseInt(sum) > 25600000){
        this.setUploadFilesError('Total file size should be less than 25MB');
      } else{
        // this.uploadImage(acceptedFiles);
        acceptedFiles.forEach(file => this.uploadImage(file));
      }
    }
  };

  render() {
    const { size, className, children, disabled, height } = this.props;
    let image;

    if (disabled) {
      return <ImageDisplay disabled size={size} image={this.image} />;
    } else if (this.isUploadingFiles) {
      image = <Spinner size={size} />;
    } else {
      image = /missing-image/.test(this.image) ? (
        <AddImage size={size} isHoveringFiles={this.isHoveringFiles} />
      ) : this.image ? (
        <ImageDisplay size={size} image={this.image} height={height} />
      ) : (
        children || <ImagePlaceholder size={size} />
      );
    }

    return (
      <Dropzone
        accept="image/*"
        onDragEnter={() => this.hoveringFiles()}
        onDragLeave={() => this.notHoveringFiles()}
        onDrop={this.onDropFiles}
        multiple
        size={size}
        className={className}>
        {image}
      </Dropzone>
    );
  }
}
